import { render, staticRenderFns } from "./EmergencyContactEditModal.vue?vue&type=template&id=e0f2c654"
import script from "./EmergencyContactEditModal.vue?vue&type=script&lang=js"
export * from "./EmergencyContactEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports